import React from 'react';
import './CheckboxField.css';

interface CheckboxFieldProps {
  label: string;
  checked: boolean;
  onChange: () => void;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ label, checked, onChange }) => (
  <div className="checkbox-field">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <label>{label}</label>
  </div>
);

export default CheckboxField;
